import { onMounted, onUnmounted, ref } from 'vue';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function useUnsavedDataWarning(initialDirty: boolean = false) {
    const isDirty = ref<boolean>(initialDirty);

    function setDirty(newDirty: boolean): void {
        isDirty.value = newDirty;
    }

    function handleBeforeUnload(event: BeforeUnloadEvent): void {
        if (isDirty.value) {
            event.preventDefault();
            // необходимо для старых браузеров: IE11, Chrome 50, Firefox 44, Safari 9.1
            // ~ в 2016 году returnValue стал deprecated
            // noinspection JSDeprecatedSymbols
            event.returnValue = '';
        }
    }

    onMounted(() => {
        window.addEventListener('beforeunload', handleBeforeUnload);
    });

    onUnmounted(() => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
    });

    return {
        isDirty,
        setDirty: setDirty,
    };
}
